import styled from "@emotion/styled";

interface IProps {
    height?: string;
    isLeftOverlayVisible: boolean;
    isRightOverlayVisible: boolean;
    width?: string;
}

export const Overlay = styled.div<IProps>`
    &::before,
    &::after {
        content: "";
        position: absolute;
        bottom: 0;
        width: ${(props) => props.width || "6rem"};
        height: ${(props) => props.height || "22.8rem"};
        z-index: 10;
    }

    &::before {
        display: ${(props) => (props.isLeftOverlayVisible ? "block" : "none")};
        left: 0;
        background: linear-gradient(to right, #f9f9f9 0%, rgba(249, 249, 249, 0) 100%);
    }

    &::after {
        display: ${(props) => (props.isRightOverlayVisible ? "block" : "none")};
        right: 0;
        background: linear-gradient(to left, #f9f9f9 0%, rgba(249, 249, 249, 0) 100%);
    }
`;
import styled from "@emotion/styled";

interface IProps {
    height?: string;
    isLeftOverlayVisible: boolean;
    isRightOverlayVisible: boolean;
    width?: string;
}

export const Overlay = styled.div<IProps>`
    &::before,
    &::after {
        content: "";
        position: absolute;
        bottom: 0;
        width: ${(props) => props.width || "6rem"};
        height: ${(props) => props.height || "22.8rem"};
        z-index: 10;
    }

    &::before {
        display: ${(props) => (props.isLeftOverlayVisible ? "block" : "none")};
        left: 0;
        background: linear-gradient(to right, #f9f9f9 0%, rgba(249, 249, 249, 0) 100%);
    }

    &::after {
        display: ${(props) => (props.isRightOverlayVisible ? "block" : "none")};
        right: 0;
        background: linear-gradient(to left, #f9f9f9 0%, rgba(249, 249, 249, 0) 100%);
    }
`;
